// client/src/pages/SignupStepTwo.js
import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import termsText from '../components/TermsText';
import GradientButton from '../components/GradientButton';

const getUserIP = async () => {
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    return data.ip;
  } catch (error) {
    return 'unknown';
  }
};

const SignupStepTwo = () => {
  const navigate = useNavigate();
  const [checkboxEnabled, setCheckboxEnabled] = useState(false);
  const [checked, setChecked] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showScrollWarning, setShowScrollWarning] = useState(false);
  const termsRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!termsRef.current) return;
      const { scrollTop, scrollHeight, clientHeight } = termsRef.current;
      if (scrollTop + clientHeight >= scrollHeight - 5) {
        setCheckboxEnabled(true);
      }
    };
    const termsEl = termsRef.current;
    if (termsEl) {
      termsEl.addEventListener('scroll', handleScroll);
    }
    return () => {
      if (termsEl) {
        termsEl.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  const handleCheckboxClick = () => {
    if (!checkboxEnabled) {
      setShowScrollWarning(true);
      return;
    }
    setChecked(!checked);
  };

  const handleIAgree = () => {
    if (!checkboxEnabled) {
      setShowScrollWarning(true);
      return;
    }
    if (checked) {
      setShowPopup(true);
    }
  };

const handleAgree = async () => {
  const utcNow = new Date().toISOString();
  const userIP = await getUserIP();
const userAgent = navigator.userAgent; // Add this line
  // sessionStorage keeps signup-flow data scoped to this tab (cleared on close)
  sessionStorage.setItem('termsAcceptedAt', utcNow);
  sessionStorage.setItem('termsSnapshot', termsText);
  sessionStorage.setItem('userIP', userIP);
sessionStorage.setItem('userAgent', userAgent); // Add this line
  navigate('/signup/preferences');
};

  const closeScrollWarning = () => {
    setShowScrollWarning(false);
  };

  return (
    <>
    <div style={{
  backgroundColor: '#f8fafc',
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '2rem 1rem'
}}>
  <div style={{
    maxWidth: '650px',
    width: '100%',
    padding: '2rem',
    backgroundColor: '#fff',
    borderRadius: '16px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
    border: '1px solid #e5e7eb',
    fontFamily: 'Arial, sans-serif'
  }}>
        <h2 style={{ textAlign: 'center', marginBottom: '1.5rem' }}>Step 2: Terms & Conditions</h2>

        <div
          ref={termsRef}
          style={{
            maxHeight: '300px',
            overflowY: 'scroll',
            padding: '1rem',
            border: '1px solid #ccc',
            borderRadius: '4px',
            backgroundColor: '#fafafa',
            fontSize: '0.95rem',
            marginBottom: '1.5rem'
          }}
        >
          <pre style={{ whiteSpace: 'pre-wrap' }}>{termsText}</pre>
        </div>

        {/* Instruction text */}
        <div style={{
          textAlign: 'center',
          fontSize: '1rem',
          color: checkboxEnabled ? '#27ae60' : '#666',
          fontWeight: checkboxEnabled ? 'bold' : 'normal',
          marginBottom: '1rem',
          padding: '0.5rem',
          fontStyle: checkboxEnabled ? 'normal' : 'italic'
        }}>
          {checkboxEnabled ? 
            '✓ You can now accept all Terms and Conditions' : 
            'Please scroll and read completely through the Terms and Conditions above to enable the checkbox and continue with signup'
          }
        </div>

        {/* Updated checkbox section with larger size and better formatting */}
        <div style={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'center',
          textAlign: 'center',
          marginBottom: '2rem',
          padding: '1rem'
        }}>
          <input
            type="checkbox"
            disabled={!checkboxEnabled}
            checked={checked}
            onChange={handleCheckboxClick}
            onClick={handleCheckboxClick}
            style={{
              width: '20px',
              height: '20px',
              marginRight: '12px',
              marginTop: '2px',
              cursor: checkboxEnabled ? 'pointer' : 'not-allowed'
            }}
          />
          <label 
            onClick={handleCheckboxClick}
            style={{
              fontSize: '1.1rem',
              lineHeight: '1.4',
              cursor: checkboxEnabled ? 'pointer' : 'not-allowed',
              color: checkboxEnabled ? '#333' : '#999',
              maxWidth: '500px'
            }}
          >
            I have completely read all the Terms and Conditions for using the LuckyLogic.ai Service and ACCEPT them in totality as written.
          </label>
        </div>

        <div style={{ marginTop: '2rem', textAlign: 'right', padding: '1rem 0' }}>
          <GradientButton
  variant="green"
  onClick={handleIAgree}
  disabled={!checked}
  style={{
    opacity: checked ? 1 : 0.6,
    cursor: checked ? 'pointer' : 'not-allowed'
  }}
>
  I Accept
</GradientButton>
        </div>
      </div>

      {/* Scroll Warning Popup */}
      {showScrollWarning && (
        <div style={popupStyle}>
          <div style={popupContentStyle}>
            <h3 style={{ color: '#e74c3c', marginBottom: '1rem' }}>Please Read All Terms</h3>
            <p style={{ fontSize: '1rem', marginBottom: '1.5rem', lineHeight: '1.4' }}>
              You need to read and scroll through the entire Terms and Conditions before you can check the box and click "I Accept".
            </p>
            <GradientButton variant="green" onClick={closeScrollWarning}>
  Got It
</GradientButton>
          </div>
        </div>
      )}

      {/* Agreement Confirmation Popup */}
      {showPopup && (
        <div style={popupStyle}>
          <div style={popupContentStyle}>
            <p style={{ fontSize: '1rem', marginBottom: '1.5rem' }}>
              After completely reading the LuckyLogic.ai Terms and Conditions, I agree to these Terms and Conditions as required to open my account.
            </p>
            <GradientButton variant="green" onClick={handleAgree}>
  I Agree
</GradientButton>
          </div>
        </div>
      )}
    </div>
  </>
  );
};

const popupStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.4)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 999
};

const popupContentStyle = {
  backgroundColor: '#fff',
  padding: '2rem',
  borderRadius: '8px',
  textAlign: 'center',
  width: '90%',
  maxWidth: '500px'
};

export default SignupStepTwo;